// extracted by mini-css-extract-plugin
module.exports = {"ProductJP":"ProductJP_ProductJP__gAYju"};